import React, { useState, useEffect } from "react";
import Checkbox from "../../genericComponents/Checkbox/Checkbox";
import PlusIcon from "../../../assets/layerlist/plus.svg?react";
import MinusIcon from "../../../assets/layerlist/minus.svg?react";
import CheckedIcon from "../../../assets/layerlist/checked.svg?react";
import UncheckedIcon from "../../../assets/layerlist/unchecked.svg?react";
import StarIcon from "../../../assets/layerlist/star.svg?react";
import EmptyStarIcon from "../../../assets/layerlist/emptyStar.svg?react";
import "./LayerlistCollapsible.css";

interface LayerlistCollapsibleProps {
    children?: React.ReactNode;
    title: string;
    isChecked: boolean;
    onCheckboxChange: (checked: boolean) => void;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    onToggle?: () => void;
    isFavorite: boolean;
    onFavoriteChange: (checked: boolean) => void;
}

const LayerlistCollapsible: React.FC<LayerlistCollapsibleProps> = ({
    children,
    title,
    isChecked,
    onCheckboxChange,
    isOpen,
    setIsOpen,
    onToggle,
    isFavorite,
    onFavoriteChange,

}) => {
    const [internalIsOpen, setInternalIsOpen] = useState(isOpen);

    const toggleCollapsible = () => {
        setIsOpen(!isOpen);
        setInternalIsOpen(!internalIsOpen);
        if (onToggle) {
            onToggle();
        }
    };

    useEffect(() => {
        setInternalIsOpen(isOpen);
    }, [isOpen]);

    return (
        <div className="layerlist-collapsible-container">
            <div className="layerlist-collapsible-header">
                <div className="layerlist-collapsible-left">
                    <Checkbox
                        id={`layerlist-checkbox-${title}`}
                        checked={isChecked}
                        onChange={onCheckboxChange}
                        checkedIcon={CheckedIcon}
                        uncheckedIcon={UncheckedIcon}
                    />
                    <label htmlFor={`layerlist-checkbox-${title}`} className="layerlist-collapsible-title">{title}</label>
                </div>
                <button className="layerlist-collapsible-toggle" onClick={toggleCollapsible}>
                    {internalIsOpen ? <MinusIcon /> : <PlusIcon />}
                </button>
                <Checkbox
                    checked={isFavorite}
                    checkedIcon={StarIcon}
                    uncheckedIcon={EmptyStarIcon}
                    id={`layerlist-checkbox-${title}` + "-star"}
                    onChange={onFavoriteChange}
                />
            </div>
            {internalIsOpen && <div className="layerlist-collapsible-content">{children}</div>}
        </div>
    );
};

export default LayerlistCollapsible;
